import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-creator-testimonial" }
const _hoisted_2 = { class: "gfu-creator-testimonial__side" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "gfu-hd gfu-hd--h4 _tc--white"
}
const _hoisted_5 = { class: "gfu-hd gfu-hd--h4 _tc--white _tc--mute _fw-n" }
const _hoisted_6 = {
  class: /*@__PURE__*/_normalizeClass(['gfu-creator-testimonial__content'])
}
const _hoisted_7 = {
  key: 0,
  class: "gfu-media gfu-media--middle _mt-6"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "gfu-media__body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: $props.imageUrl,
        alt: $props.company,
        class: "gfu-creator-testimonial__image"
      }, null, 8 /* PROPS */, _hoisted_3),
      _createElementVNode("div", null, [
        ($props.creator)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString($props.creator), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("h4", _hoisted_5, _toDisplayString($props.company), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString($props.content) + " ", 1 /* TEXT */),
      ($options.isAddnotationVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              src: $props.projectImageUrl,
              alt: $props.projectName,
              class: "_mr-3",
              height: "64"
            }, null, 8 /* PROPS */, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$format($props.fundsGathered, 'C0', '$')), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createTextVNode(" raised from ", -1 /* CACHED */)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$format($props.backersCount, 'N0')), 1 /* TEXT */),
              _createTextVNode(" backers during the crowdfunding campaign of " + _toDisplayString($props.projectName) + ". ", 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}